import { render, staticRenderFns } from "./DialogBatchSendXero.vue?vue&type=template&id=3bced3a5&scoped=true"
import script from "./DialogBatchSendXero.vue?vue&type=script&lang=js"
export * from "./DialogBatchSendXero.vue?vue&type=script&lang=js"
import style0 from "./DialogBatchSendXero.vue?vue&type=style&index=0&id=3bced3a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bced3a5",
  null
  
)

export default component.exports